export const IDX_URL = 'https://activeadult.lovedonesfirst.com/idx/search';
